<template>
    <div class="box">
        <el-button type="primary" icon="el-icon-plus" @click="add">新建</el-button>
        <!-- 表格 -->
        <div class="tab">
            <el-table :data="tableData" style="width: 100%;" border v-loading="loading" element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading" :header-row-style="{ 'font-weight': 'bold', 'color': '#9196A0' }">
                <el-table-column prop="platform" label="平台">
                    <!-- <div>{{ platform == '0' ? 'Android' : 'IOS' }}</div> -->
                    <template slot-scope="scope">
                        {{ scope.row.platform == '0' ? 'Android' : 'IOS' }}
                    </template>
                </el-table-column>
                <el-table-column prop="version" label="版本号">
                </el-table-column>
                <el-table-column prop="updateUrl" label="更新地址">
                </el-table-column>
                <el-table-column prop="updateNotes" label="更新备注">
                </el-table-column>
                <el-table-column prop="isMandatory" label="是否强制刷新">
                    <template slot-scope="scope">
                        {{ scope.row.isMandatory == '0' ? '否' : '是' }}
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间">
                </el-table-column>
                <el-table-column label="操作" prop="id">
                    <template slot-scope="scope">
                        <el-link :underline="false" type="danger" @click="delVersions(scope.row.id)">删除</el-link>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页 -->
        <div class="paginationBox">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage4" :page-sizes="[10, 20, 30, 40]" :page-size="10"
                layout="total, sizes, prev, pager, next, jumper" :total="total" class="pagination">
            </el-pagination>
        </div>
        <AddView :message="dialogFormVisible" @closeFunction='getDialogFormVisible' @add-success="versionsListFunc">
        </AddView>
    </div>
</template>

<script>
import AddView from './components/AddView.vue';
import versionsApi from '@/api/setting/versions.js';
export default {
    data() {
        return {
            tableData: [],
            total: 0, // 总数
            currentPage4: 1,
            dialogFormVisible: false,
            loading: false, // 表格加载
            pageSize: 10, // 每页显示多少条数据
            pageIndex: 1,
        }
    },
    components: { AddView },
    methods: {
        // 版本列表
        versionsListFunc(pageIndex, pageSize) {
            // console.log(pageIndex, pageSize)
            this.loading = true
            versionsApi.getVersionsList({ pageIndex: pageIndex, pageSize: pageSize }).then(response => {
                this.total = response.data.total
                this.tableData = response.data.records;
                this.loading = false
            }).catch(error => {
                // console.error(error);
            });
        },
        // 每页显示多少条数据
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.pageSize = val;
            this.versionsListFunc(this.pageIndex, val);
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.pageIndex = val;
            this.versionsListFunc(val, this.pageSize);
        },
        // 新增
        add() {
            this.dialogFormVisible = true;
        },
        getDialogFormVisible(value) {
            this.dialogFormVisible = value;
        },
        // 删除
        delVersions(id) {
            this.$confirm('此操作将永久删除此条信息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.loading = true;
                versionsApi.getDelVersions({ id: id }).then(res => {
                    // console.log(res)

                    this.versionsListFunc(this.pageIndex, this.pageSize);
                    this.loading = false;
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });

                }).catch(err => {
                    // console.log(err);
                })

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
    },
    mounted() {
        this.versionsListFunc(this.pageIndex, this.pageSize);
    },
}
</script>

<style scoped>
.tab {
    margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/versions/index.vue